var rb = require('crypto').randomBytes;
module.exports = function() {
  return rb(16);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/uuid/rng.js
// module id = 441
// module chunks = 0